import { render, staticRenderFns } from "./SortButton.vue?vue&type=template&id=68d7a1c7&"
import script from "./SortButton.vue?vue&type=script&lang=js&"
export * from "./SortButton.vue?vue&type=script&lang=js&"
import style0 from "./SortButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports